import {
  PLAYER_HP,
} from '../config';

export class Hud {
  private readonly hpFill = this.getElement('#hp-bar-fill');
  private readonly hpText = this.getElement('#hp-text');
  private readonly scoreValue = this.getElement('#score-value');
  private readonly waveValue = this.getElement('#wave-value');
  private readonly enemyCount = this.getElement('#enemy-count');
  private readonly livesValue = this.getElement('#lives-value');
  private readonly cooldownIndicator = this.getElement('#cooldown-indicator');
  private readonly cooldownFill = this.getElement('#cooldown-fill');

  private readonly menuOverlay = this.getElement('#menu-overlay');
  private readonly gameoverOverlay = this.getElement('#gameover-overlay');
  private readonly waveOverlay = this.getElement('#wave-overlay');
  private readonly finalScore = this.getElement('#final-score');
  private readonly finalWave = this.getElement('#final-wave');
  private readonly waveText = this.getElement('#wave-text');

  showMenu(): void {
    this.menuOverlay.classList.remove('hidden');
    this.gameoverOverlay.classList.add('hidden');
    this.waveOverlay.classList.add('hidden');
  }

  hideMenu(): void {
    this.menuOverlay.classList.add('hidden');
  }

  showGameOver(score: number, wave: number): void {
    this.gameoverOverlay.classList.remove('hidden');
    this.finalScore.textContent = String(score);
    this.finalWave.textContent = String(wave);
  }

  hideGameOver(): void {
    this.gameoverOverlay.classList.add('hidden');
  }

  showWaveComplete(wave: number): void {
    this.waveOverlay.classList.remove('hidden');
    this.waveText.textContent = `第 ${wave} 波完成!`;
    setTimeout(() => {
      this.waveOverlay.classList.add('hidden');
    }, 2000);
  }

  showWaveStart(wave: number): void {
    this.waveOverlay.classList.remove('hidden');
    this.waveText.textContent = `第 ${wave} 波`;
    setTimeout(() => {
      this.waveOverlay.classList.add('hidden');
    }, 1500);
  }

  updateHp(hp: number): void {
    const pct = Math.max(0, Math.min(100, (hp / PLAYER_HP) * 100));
    this.hpFill.style.width = `${pct}%`;
    this.hpText.textContent = `${Math.ceil(hp)} HP`;

    this.hpFill.classList.remove('warning', 'danger');
    if (pct <= 30) {
      this.hpFill.classList.add('danger');
    } else if (pct <= 50) {
      this.hpFill.classList.add('warning');
    }
  }

  updateScore(score: number): void {
    this.scoreValue.textContent = String(score);
  }

  updateWave(wave: number): void {
    this.waveValue.textContent = String(wave);
  }

  updateEnemyCount(count: number): void {
    this.enemyCount.textContent = String(count);
  }

  updateLives(lives: number): void {
    this.livesValue.textContent = String(lives);
  }

  updateCooldown(ratio: number): void {
    if (ratio >= 1) {
      this.cooldownIndicator.classList.add('hidden');
    } else {
      this.cooldownIndicator.classList.remove('hidden');
      this.cooldownFill.style.width = `${ratio * 100}%`;
    }
  }

  private getElement(selector: string): HTMLElement {
    const el = document.querySelector<HTMLElement>(selector);
    if (!el) throw new Error(`Missing HUD element: ${selector}`);
    return el;
  }
}
